export const LOAD_MOVIMIENTOS_BANCARIOS = 'LOAD_MOVIMIENTOS_BANCARIOS';
export const SET_MOVIMIENTOS_BANCARIOS = 'SET_MOVIMIENTOS_BANCARIOS';

export const SAVE_MOVIMIENTO_BANCARIO = 'SAVE_MOVIMIENTO_BANCARIO';
export const SAVED_MOVIMIENTO_BANCARIO = 'SAVED_MOVIMIENTO_BANCARIO';

export const loadMovimientosBancarios = (idBanco, idCuenta) => ({
    type: LOAD_MOVIMIENTOS_BANCARIOS,
    idBanco,
    idCuenta,
});

export const setMovimientosBancarios = (movimientosBancarios) => ({
    type: SET_MOVIMIENTOS_BANCARIOS,
    movimientosBancarios,
});

export const saveMovimientoBancario = (movimientoBancario) => ({
    type: SAVE_MOVIMIENTO_BANCARIO,
    movimientoBancario,
});

export const savedMovimientoBancario = (movimientoBancario) => ({
    type: SAVED_MOVIMIENTO_BANCARIO,
    movimientoBancario,
});

const initialState = {
    movimientosBancarios: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
    case SAVED_MOVIMIENTO_BANCARIO: {
        const { movimientoBancario } = action;
        const index = state.movimientosBancarios.findIndex((item) => item.id === movimientoBancario.id);
        if (index === -1) {
            return {
                ...state,
                movimientosBancarios: state.movimientosBancarios.concat(movimientoBancario),
            };
        }
        const updated = state.movimientosBancarios
            .slice(0, index)
            .concat([movimientoBancario])
            .concat(state.movimientosBancarios.slice(index + 1));
        return {
            ...state,
            movimientosBancarios: updated,
        };
    }
    case SET_MOVIMIENTOS_BANCARIOS: {
        const { movimientosBancarios } = action;
        return {
            ...state,
            movimientosBancarios,
        };
    }
    default:
        return state;
    }
};
